export default "__VITE_ASSET__vWZ0kdCM__"